import React from 'react';

import { SVGComponentProps } from './svg.types';

const DeadlineSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <rect y="0.00244141" width="32" height="32" rx="4" fill="#DF1C41" />
      <path
        d="M18.7002 7.66919H13.3002C10.1669 7.66919 9.92519 10.4859 11.6169 12.0192L20.3835 19.9859C22.0752 21.5192 21.8335 24.3359 18.7002 24.3359H13.3002C10.1669 24.3359 9.92519 21.5192 11.6169 19.9859L20.3835 12.0192C22.0752 10.4859 21.8335 7.66919 18.7002 7.66919Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeadlineSVG;
